import { screenshot } from './screenshot.js'

export const thumbnail = async ({
  id = '',
  model = null,
  data = null,
  options = { encoding: 'base64', type: 'png' } as any,
  context = {}
} = {}) => {
  return await screenshot({
    id,
    model,
    data,
    options,
    isThumbnail: true,
    context
  })
}
